import { useContext } from 'react';
import { DevHubAlert } from '@devxdiscover/devhub-ui';
import { useNavigate } from 'react-router-dom';
import { Progress } from '@backstage/core-components';
import { ApiPortalContext } from '../../contexts/ApiPortalContext';
import ApiPortalTabbedPage from './ApiPortalTabbedPage';
import ApiPortalDocs from './ApiPortalDocs';

/**
 * A component to render the API Portal data feed management page.
 */
export const ApiPortalDataFeedManagement = () => {
  const navigate = useNavigate();
  const { loading, error, formattedOrgName } = useContext(ApiPortalContext);

  const handleBackClick = () => {
    navigate(`/api-portals`);
  };

  if (loading) {
    return <Progress />;
  } else if (error) {
    return (
      <DevHubAlert severity="error">
        Error loading API Portal organization data: {error.message}
      </DevHubAlert>
    );
  }

  return (
    <ApiPortalTabbedPage
      formattedOrgName={formattedOrgName}
      dataFeedContent={<ApiPortalDocs isDataFeed />}
      handleBackClick={handleBackClick}
    />
  );
};
